import React from "react";
import classes from "./style/Preloader.module.css";

const Preloader = () => {
  const list = Array.from({ length: 12 });
  return (
    <div className={classes.container}>
      <div className={classes.pl}>
        {list.map((item, index) => {
          return <div key={index} className={classes.pl__dot}></div>;
        })}
        <div className={classes.pl__text}>Загрузка…</div>
      </div>
    </div>
  );
};

export default Preloader;
